import Price from './Price.vue';

export default function install(Vue) {
  Vue.component(Price.name, Price)
}
